<template>
  <div style="display: inline-block">
    <el-dialog
      title="预览页面"
      :visible="visible"
      append-to-body
      destroy-on-close
      width="430px"
      @close="handleCloseDialog"
    >
      <div class="title">
        <div class="setting">×</div>
        <div class="font">{{ originData.title }}活动预览</div>
        <div class="setting">···</div>
      </div>
      <div class="container">
        <div class="cover-selector" v-if="originData.cover_list.annex_content">
          <img
            v-if="originData.cover_list.annex_type === 1"
            :src="originData.cover_list.annex_content"
          />
          <video
            v-if="originData.cover_list.annex_type === 2"
            :src="originData.cover_list.annex_content"
            controls
          ></video>
        </div>
        <div class="cover-selector" v-else>
          <i>活动封面图</i>
        </div>

        <el-form>
          <el-form-item label="填写信息" class="item1"></el-form-item>
          <el-form-item
            v-for="item in originData.viewList"
            :key="item.preset_form_id"
            :label="item.title + ':'"
            :class="{ require: item.is_require }"
            v-show="item.is_show"
          >
            <el-input
              v-if="item.preset_form_id === 1"
              :placeholder="`请输入${item.title}`"
              disabled
            ></el-input>

            <el-radio-group v-else-if="item.preset_form_id === 2">
              <el-radio
                v-for="(it, index) in item.default_value"
                :key="index"
                :label="it"
                disabled
                >{{ it }}
              </el-radio>
            </el-radio-group>

            <el-date-picker
              v-else-if="item.preset_form_id === 3"
              v-model="data.date"
              type="datetime"
              placeholder="选择出生日期"
              disabled
            >
            </el-date-picker>

            <el-input
              v-else-if="item.preset_form_id === 4"
              placeholder="请填写手机号码"
              disabled
            ></el-input>

            <el-input
              v-else-if="item.preset_form_id === 5"
              placeholder="请选择区域"
              disabled
            ></el-input>

            <el-select
              v-else-if="item.preset_form_id === 6"
              placeholder="请选择意向科目"
              v-model="item.default_value"
              multiple
              disabled
            >
              <el-option
                v-for="item in subjectsList"
                :key="item.subject_id"
                :label="item.subject_title"
                :value="item.subject_id"
              >
              </el-option>
            </el-select>

            <div v-else>
              <div v-if="item.type === 1">
                <el-input
                  class="customInput"
                  :placeholder="`请输入${item.title}`"
                  disabled
                >
                </el-input>
              </div>
              <div v-if="item.type === 2" class="flex">
                <el-radio-group disabled>
                  <el-radio
                    v-for="(it, index) in item.default_value"
                    :key="index"
                    :label="it.label"
                    >{{ it.label }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div v-if="item.type === 3" class="flex">
                <el-radio-group>
                  <el-checkbox
                    v-for="(it, index) in item.default_value"
                    :key="index"
                    :label="it.label"
                    disabled
                    >{{ it.label }}</el-checkbox
                  >
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
        </el-form>

        <el-form
          class="form2"
          v-if="originData.descriptionValue || originData.desc_list.length > 0"
        >
          <el-form-item label="活动说明" class="item1"> </el-form-item>

          <p class="description">{{ originData.descriptionValue }}</p>

          <el-form-item class="media">
            <span v-for="(item, index) in originData.desc_list" :key="index">
              <div class="cover-selector" v-if="item.annex_type !== 3">
                <img v-if="item.annex_type === 1" :src="item.annex_content" />
                <video
                  v-if="item.annex_type === 2"
                  :src="item.annex_content"
                ></video>
              </div>
            </span>
          </el-form-item>
        </el-form>

        <div class="submit">
          <el-radio v-model="data.agree" disabled>
            我已阅读并同意《隐私政策》
          </el-radio>
          <el-button
            v-if="originData.is_pay"
            class="mwow-button-filled info large"
          >
            <div v-if="!Number(originData.product_type)">提交信息</div>
            <div v-if="Number(originData.product_type) === 1">购买课包</div>
            <div v-if="Number(originData.product_type) === 2">购买课程</div>
          </el-button>
          <el-button v-else class="mwow-button-filled info large">
            提交信息
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["originData", "visible"],
  data() {
    return {
      data: {
        agree: false,
      },
      subjectsList: [],
    };
  },
  watch: {
    visible: {
      handler(n) {
        // console.log("最新数据", this.originData);
        if (n) {
          this.originData.viewList.forEach((item) => {
            if (item.preset_form_id === 2) {
              if (typeof item.default_value === "string") {
                item.default_value = JSON.parse(item.default_value);
              }
            }
            // 大于 6 的 id 需要进行 parse 解析
            if (item.preset_form_id > 6) {
              // 后端返回的数据为字符串，第一次需要做处理
              if (typeof item.default_value === "string") {
                item.default_value = item.default_value
                  ? JSON.parse(item.default_value).map((it) => {
                      if (typeof it !== "object") {
                        return {
                          label: it,
                        };
                      } else {
                        return {
                          label: it.label,
                        };
                      }
                    })
                  : "";
              }
            }
          });
        }
      },
    },
  },
  methods: {
    handleCloseDialog() {
      this.$emit("change", false);
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.title {
  padding: 10px 15px;
  height: 12px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  .font {
    flex: 1;
    text-align: center;
  }
  .setting {
    width: 18px;
    height: 18px;
    font-size: 18px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
  }
}
.container {
  background: rgba(248, 250, 253, 1);
  padding: 10px 15px;
  /deep/.el-form {
    margin: 15px 0;
    padding: 0px 15px 1px 15px;
    background: white;
    border-radius: 5px;
    .item1 {
      font-weight: 700;
      margin: 0 !important;
      .el-form-item__label {
        padding-left: 10px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        text-align: left;
      }
    }

    .el-form-item {
      display: flex;
      margin-bottom: 10px;
      .el-form-item__label {
        width: 130px !important;
        padding-right: 10px;
      }

      .el-form-item__content {
        width: 74%;

        div:nth-child(1) {
          width: 100%;
        }
        .el-select {
          height: 30px;
          .el-input__inner {
            height: 30px;
          }
        }
      }
    }
    .require {
      .el-form-item__label {
        width: 130px !important;
        &::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }
      }
    }
    .item {
      .el-form-item__label {
        &::before {
          content: "*";
          color: #f56c6c;
          margin-right: 3px;
        }
      }
    }
    .el-form-item__content {
      margin: 0 auto;
      div {
        width: 100%;
      }
    }
    .customInput {
      .el-input__inner {
        height: 60px !important;
        position: relative;
        &::-webkit-input-placeholder {
          position: absolute;
          top: 8px;
        }
      }
    }
  }
  .submit {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    .el-radio {
      margin: 0 !important;
      display: flex;
      justify-content: center;
    }
    button {
      border: 1px solid red;
      margin: 5px 0 0px 0;
      width: 100%;
      cursor: default !important;
      border-radius: 8px;
      height: 40px !important;
      line-height: 20px !important;
    }
  }
}
.form2 {
  padding: 0px 15px 0px 15px !important;
}
.cover-selector {
  display: block;
  line-height: 224px;
  height: 224px;
  overflow: hidden;
  text-align: center;
  margin: 5px auto;
  border: 1px dashed #d9d9d9;
  position: relative;
  border-radius: 4px;
  .el-image {
    display: flex;
    justify-content: center;
  }
  img {
    object-fit: contain;
    width: 100%;
  }
  video {
    object-fit: contain;
    width: 100%;
  }
}

/deep/.media {
  margin-top: 10px;
  .el-form-item__content {
    margin: 0 !important;
    width: 100% !important;
    .cover-selector {
      margin: 0 10px;
      display: inline-block;
      width: 160px !important;
      height: 90px !important;
      line-height: 0;
    }
  }
}

.el-radio,
.el-checkbox {
  margin: 5px 20px 0 0 !important;
  /deep/.el-radio__label,
  .el-checkbox__label {
    white-space: break-spaces !important;
  }
}

.description {
  width: 95%;
  margin: 0px auto;
  line-height: 20px;
  color: rgba(51, 51, 51, 1);
}
</style>
